import {Component, EventEmitter, Output} from '@angular/core';
import {NbinputExcelService} from "./nbinput-excel.service";


@Component({
  selector: 'nbinput-excel',
  template: require('./nbinput-excel.component.html'),
  styles: [require('./nbinput-excel.component.scss')],
})

export class NbinputExcelComponent{

  @Output() public loaded: EventEmitter<any> = new EventEmitter();
  onchange(e){
    if (e&&e.target&&e.target.files&&e.target.files.length>0){
      this.excel.loadExcelFileAsJson(e.target.files[0]).then(f=>{
        this.loaded.emit(f);
      });
      e.target.value = '';
      // e.target.files = [];
    }
  }

  constructor(
    private excel:NbinputExcelService
  ){}
}
